// Plans and seat prices as the approved prototype shows them (75-billing.js PLANS, launch prices v3).
// Billing (phase 9) reads the live price version from the database instead.
export const PLANS: Record<string, { en: string; ar: string; rank: number; fee: number; incIss: number; incOff: number; issuer: number; office: number }> = {
  team: { en: 'Team', ar: 'الفريق', rank: 1, fee: 99, incIss: 1, incOff: 1, issuer: 35, office: 15 },
  business: { en: 'Business', ar: 'الأعمال', rank: 2, fee: 299, incIss: 3, incOff: 0, issuer: 45, office: 25 },
  enterprise: { en: 'Enterprise', ar: 'المؤسسات', rank: 3, fee: 1499, incIss: 10, incOff: 0, issuer: 39, office: 19 },
};
export type Seats = { issuer: number; office: number };
/** The plan fee includes some seats; an unused included issuer seat can be used by an office person (DECISIONS 10 Q3). */
export function monthly(plan: string, s: Seats) {
  const p = PLANS[plan]; if (!p) return 0;
  const xIss = Math.max(0, s.issuer - p.incIss), spare = Math.max(0, p.incIss - s.issuer);
  const xOff = Math.max(0, s.office - p.incOff - spare);
  return p.fee + xIss * p.issuer + xOff * p.office;
}
export const seatCost = (plan: string, s: Seats, type: keyof Seats, n: number) => monthly(plan, { ...s, [type]: s[type] + n }) - monthly(plan, s);
/** Supervisor and auditor need Business or higher (ARCHITECTURE §10). */
export const hasAdvRoles = (plan: string) => (PLANS[plan]?.rank ?? 0) >= 2;
